var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',{staticClass:"table-head"},[(_vm.fields)?_c('tr',[_vm._l((_vm.fields),function(field,i){return _c('TheadTh',{key:`${i}+${field.key}+${field.type}`,attrs:{"field":field}})}),(_vm.actions)?_c('th',{staticClass:"table-head__actions"}):_vm._e()],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }